<template>
  <div class="row q-col-gutter-md">
    <package
      v-for="(item, index) in packages"
      :index="index"
      :package="item"
      :key="item.id"
    ></package>
  </div>
</template>

<script>
import Package from "../components/Package";

export default {
  components: {
    Package,
  },
  computed: {
    packages: {
      get() {
        return this.$store.state.pack.packages;
      },
      set(val) {
        this.$store.commit("pack/SET_PACKAGES", val);
      },
    },
  },
};
</script>